export default __webpack_public_path__ + "maps-overview-quickstart-result-960-19eb7066cc6b4ddbd6b91c01584e3af9.png";